import alt from 'framework/alt';
import HelpActions from 'actions/HelpActions';

class HelpStore {
  constructor() {
    this.state = {
      isLoaded: false,
      currentNode: undefined,
      nodeHierarchy: undefined,
      error: undefined,
    };

    this.bindListeners({
      getHelpStarted: HelpActions.getHelpStarted,
      getHelpSucceeded: HelpActions.getHelpSucceeded,
      getHelpFailed: HelpActions.getHelpFailed,
    });
  }

  getHelpStarted() {
    this.setState({
      isLoaded: false,
    });
  }

  getHelpSucceeded(params) {
    this.setState({
      nodeHierarchy: params.nodeHierarchy,
      currentNode: params.currentNode,
      isLoaded: true,
    });
  }

  getHelpFailed(error) {
    this.setState({
      error,
      isLoaded: false,
    });
  }
}

export default alt.createStore(HelpStore, 'HelpStore');
